<template>
  <validation-observer v-slot="{ handleSubmit, changed }" ref="formValidator">
    <b-form role="form" @submit.prevent="handleSubmit(updatePassword)">
      <base-input
        v-model="model.currentPassword"
        label="Current password"
        name="Current password"
        type="password"
        placeholder="********"
        :rules="{ required: true }"
        :debounce="300"
      ></base-input>
      <base-input
        v-model="model.newPassword"
        label="New password (min. 8 characters)"
        name="New password"
        type="password"
        placeholder="********"
        :rules="{ required: true, min: 8 }"
        vid="newPassword"
        :debounce="300"
      ></base-input>
      <base-input
        v-model="model.newPasswordConfirmation"
        label="New password (again)"
        name="New password confirmation"
        type="password"
        placeholder="********"
        :rules="{ required: true, min: 8, confirmed:'newPassword' }"
        vid="newPasswordConfirmation"
        :debounce="300"
      ></base-input>
      <base-button block type="secondary" native-type="submit" :disabled="!changed">
        <span v-if="!isUpdating">Update password</span>
        <span v-else>
          Please wait&hellip;
          <i class="fa fa-spin fa-spinner"></i>
        </span>
      </base-button>
    </b-form>
  </validation-observer>
</template>

<script>
export default {
  data() {
    return {
      isUpdating: false,
      model: {
        currentPassword: null,
        newPassword: null,
        newPasswordConfirmation: null
      }
    };
  },
  methods: {
    updatePassword: function() {
      this.isUpdating = true;

      this.axios
        .put(`/v1/users/me/password`, {
          currentPassword: this.model.currentPassword,
          newPassword: this.model.newPassword
        })
        .then(response => {
          this.isUpdating = false;
          this.$notify({
            message: "Password updated",
            timeout: 2000,
            icon: "fa fa-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success"
          });

          // emit email address updated event
          this.$emit("updated-password", response.data);
        })
        .catch(error => {
          this.isUpdating = false;
          let errorMessage = "Error updating password";

          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            errorMessage = error.response.data.message;
          }

          this.$notify({
            message: errorMessage,
            timeout: 2000,
            icon: "fa fa-exclamation-triangle",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger"
          });
        });
    }
  }
};
</script>